import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { mockData } from '../mock';
import { toast } from 'sonner';
import { submitFormWithGeoLocation } from '../services/api';

const initialData = { name: '', email: '', countryCode: '+1', contactNumber: '', message: '' };

const LeadForm = ({ onSuccess, idPrefix = 'form', submitLabel = 'Submit Request', className = 'space-y-4 mt-4' }) => {
  const [formData, setFormData] = useState(initialData);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);
    try {
      const result = await submitFormWithGeoLocation(formData);
      if (result.success) {
        toast.success(result.message || 'Thank you! Your request has been submitted.');
        setFormData(initialData);
        onSuccess?.();
        if (result.customerId) {
          setTimeout(() => {
            window.location.href = `/thanks/?customerid=${result.customerId}`;
          }, 500);
        }
      } else {
        toast.error(result.error || 'Failed to submit form. Please try again.');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      toast.error('An error occurred. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <form onSubmit={handleSubmit} className={className}>
      <div>
        <Label htmlFor={`${idPrefix}-name`}>Name *</Label>
        <Input
          id={`${idPrefix}-name`}
          value={formData.name}
          onChange={(e) => handleChange('name', e.target.value)}
          required
          placeholder="Your full name"
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor={`${idPrefix}-email`}>Email *</Label>
        <Input
          id={`${idPrefix}-email`}
          type="email"
          value={formData.email}
          onChange={(e) => handleChange('email', e.target.value)}
          required
          placeholder="your.email@example.com"
          className="mt-1"
        />
      </div>

      <div>
        <Label htmlFor={`${idPrefix}-contact`}>Contact Number *</Label>
        <div className="flex gap-2 mt-1">
          <select
            value={formData.countryCode}
            onChange={(e) => handleChange('countryCode', e.target.value)}
            className="w-[140px] bg-white border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-secondary focus:border-secondary"
          >
            {mockData.countryCodes.map((item) => (
              <option key={item.code} value={item.code}>
                {item.code} {item.country}
              </option>
            ))}
          </select>
          <Input
            id={`${idPrefix}-contact`}
            type="tel"
            value={formData.contactNumber}
            onChange={(e) => handleChange('contactNumber', e.target.value)}
            required
            placeholder="123-456-7890"
            className="flex-1 bg-white"
          />
        </div>
      </div>

      <div>
        <Label htmlFor={`${idPrefix}-message`}>Message</Label>
        <Textarea
          id={`${idPrefix}-message`}
          value={formData.message}
          onChange={(e) => handleChange('message', e.target.value)}
          placeholder="Tell us about your trademark needs..."
          className="mt-1 min-h-[100px]"
        />
      </div>

      <Button
        type="submit"
        disabled={isSubmitting}
        className="w-full bg-secondary hover:bg-secondary/90 text-white font-semibold py-6 shadow-lg hover:shadow-secondary/50 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSubmitting ? 'Submitting...' : submitLabel}
      </Button>
    </form>
  );
};

export default LeadForm;
